import * as React from "react";

import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  Card,
  CardContent,
  CardHeader,
  SpeedDial,
  SpeedDialIcon,
  SpeedDialAction,
} from "@mui/material";
import { Form, useLoaderData, useNavigate, useParams } from "react-router-dom";
import CategoryIcon from "@mui/icons-material/Category";
import { Result } from "../../types/Result";
import { ExamType } from "./type";

export default function ExamTypeForm() {
  const params = useParams();
  const navigate = useNavigate();
  const data = useLoaderData() as Result<ExamType>;

  const [values, setValues] = React.useState<ExamType>(data.data!);

  const handleCancel = () => {
    navigate(-1); // Go back to previous page
  };

  return (
    <>
      <Card>
        <CardHeader
          title={params.code ? "Sınav Türü Düzenle" : "Yeni Sınav Türü"}
        />

        <CardContent>
          <Form method="post">
            <input type="hidden" name="code" value={values.code} />
            {/* Code field */}
            <TextField
              fullWidth
              required
              id="code"
              name="code"
              label="Kod"
              defaultValue={values.code}
              margin="normal"
              variant="outlined"
              disabled={params.code !== "new"} // Disable if editing an existing exam type
            />

            {/* Name field (note: in your interface this is a number) */}
            <TextField
              fullWidth
              required
              id="name"
              name="name"
              label="İsim"
              type="string"
              defaultValue={values.name}
              margin="normal"
              variant="outlined"
            />

            {/* Explanation field */}
            <TextField
              fullWidth
              id="explanation"
              name="explanation"
              label="Açıklama"
              defaultValue={values.explanation}
              margin="normal"
              variant="outlined"
              multiline
              rows={4}
            />

            {/* Error messages */}
            {data?.errors && data.errors.length > 0 && (
              <Box sx={{ mt: 2, color: "error.main" }}>
                {data.errors.map((error, index) => (
                  <Typography key={index} color="error">
                    {error}
                  </Typography>
                ))}
              </Box>
            )}

            {/* Action buttons */}
            <Box
              sx={{ mt: 3, display: "flex", justifyContent: "space-between" }}
            >
              <Button variant="outlined" onClick={handleCancel}>
                İptal
              </Button>
              <Button type="submit" variant="contained" color="primary">
                Kaydet
              </Button>
            </Box>
          </Form>
        </CardContent>
      </Card>
      <SpeedDial
        ariaLabel="SpeedDial basic example"
        sx={{ position: "absolute", bottom: 16, right: 16 }}
        icon={<SpeedDialIcon />}
      >
        <SpeedDialAction
          icon={<CategoryIcon />}
          tooltipTitle={"Kategoriler"}
          onClick={() => navigate("/examTypeCategories/" + params.code)}
        />
      </SpeedDial>
    </>
  );
}
